(function () {
    'use strict';

    function getMOQ(variantId) {
        if (window.NFCKEY_VARIANT_MOQ && window.NFCKEY_VARIANT_MOQ[variantId]) {
            return window.NFCKEY_VARIANT_MOQ[variantId];
        }
        return 50; // fallback if metafield is missing
    }

    function isDesignerProduct(item) {
        if (!item.properties) return false;
        return item.properties.design_id || item.properties['_design_id'];
    }

    function injectStyles() {
        if (document.getElementById('designer-moq-styles')) return;
        var style = document.createElement('style');
        style.id = 'designer-moq-styles';
        style.textContent = `
            #designer-cart-errors {
                display: none;
                background: #fff;
                border: 2px solid #00c767;
                border-radius: 999px;
                padding: 14px 24px;
                margin-bottom: 24px;
                font-family: var(--font-body-family, sans-serif);
            }

            #designer-cart-errors .moq-error__inner {
                display: flex;
                align-items: center;
                gap: 12px;
                flex-wrap: wrap;
            }

            #designer-cart-errors .moq-error__icon {
                width: 22px;
                height: 22px;
                background: #00c767;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                font-size: 13px;
                font-weight: 700;
                color: #000;
                line-height: 1;
            }

            #designer-cart-errors .moq-error__text {
                font-size: 13px;
                color: #111;
                line-height: 1.5;
            }

            #designer-cart-errors .moq-error__text strong {
                font-weight: 700;
            }

            #designer-cart-errors .moq-error__text .moq-required {
                color: #00c767;
                font-weight: 600;
            }

            #designer-cart-errors .moq-error__hint {
                font-size: 12px;
                color: #888;
                margin-left: 34px;
                margin-top: 4px;
                line-height: 1.5;
            }

            .designer-moq-error {
                font-size: 12px;
                color: #888;
                margin-top: 4px;
                font-family: var(--font-body-family, sans-serif);
            }
        `;
        document.head.appendChild(style);
    }

    function validateCart() {
        fetch('/cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) {
                var hasError = false;
                var errorLines = [];

                cart.items.forEach(function (item, index) {
                    if (isDesignerProduct(item)) {
                        var MOQ = getMOQ(item.variant_id);
                        var lineNum = index + 1;
                        var qtyInput = document.querySelector('input[data-cart-line="' + lineNum + '"]');
                        var cartItem = qtyInput ? qtyInput.closest('.cart-item') : null;
                        var errorElement = cartItem ? cartItem.querySelector('.designer-moq-error') : null;

                        if (qtyInput) {
                            qtyInput.setAttribute('min', MOQ);
                        }

                        if (item.quantity < MOQ) {
                            hasError = true;
                            errorLines.push({
                                title: item.product_title,
                                current: item.quantity,
                                required: MOQ
                            });

                            if (qtyInput) {
                                if (!errorElement && cartItem) {
                                    var error = document.createElement('div');
                                    error.className = 'designer-moq-error';
                                    error.textContent = 'Minimum ' + MOQ + ' units required';
                                    qtyInput.parentNode.appendChild(error);
                                }
                            }
                        } else {
                            if (errorElement) {
                                errorElement.remove();
                            }
                        }
                    }
                });

                // Checkout button
                var checkoutBtn = document.querySelector('[name="checkout"]') ||
                    document.querySelector('#checkout') ||
                    document.querySelector('.cart__checkout-button');

                if (checkoutBtn) {
                    if (hasError) {
                        checkoutBtn.disabled = true;
                        checkoutBtn.style.opacity = '0.4';
                        checkoutBtn.style.cursor = 'not-allowed';
                        checkoutBtn.style.pointerEvents = 'none';
                    } else {
                        checkoutBtn.disabled = false;
                        checkoutBtn.style.opacity = '';
                        checkoutBtn.style.cursor = '';
                        checkoutBtn.style.pointerEvents = '';
                    }
                }

                // Error banner
                var errorBanner = document.getElementById('designer-cart-errors');

                if (hasError) {
                    if (!errorBanner) {
                        errorBanner = document.createElement('div');
                        errorBanner.id = 'designer-cart-errors';

                        var cartForm = document.querySelector('form[action="/cart"]') ||
                            document.querySelector('#cart-form') ||
                            document.querySelector('.cart');
                        if (cartForm) {
                            cartForm.insertBefore(errorBanner, cartForm.firstChild);
                        }
                    }

                    while (errorBanner.firstChild) {
                        errorBanner.removeChild(errorBanner.firstChild);
                    }

                    errorLines.forEach(function (line) {
                        var inner = document.createElement('div');
                        inner.className = 'moq-error__inner';

                        var icon = document.createElement('div');
                        icon.className = 'moq-error__icon';
                        icon.textContent = '!';

                        var text = document.createElement('div');
                        text.className = 'moq-error__text';
                        var titleNode = document.createElement('strong');
                        titleNode.textContent = line.title;
                        var reqSpan = document.createElement('span');
                        reqSpan.className = 'moq-required';
                        reqSpan.textContent = line.required + ' units';
                        text.appendChild(titleNode);
                        text.appendChild(document.createTextNode(' requires a minimum of '));
                        text.appendChild(reqSpan);
                        text.appendChild(document.createTextNode(' — currently ' + line.current + ' in cart'));

                        inner.appendChild(icon);
                        inner.appendChild(text);
                        errorBanner.appendChild(inner);
                    });

                    var hint = document.createElement('div');
                    hint.className = 'moq-error__hint';
                    hint.textContent = 'Update the quantity above to proceed to checkout.';
                    errorBanner.appendChild(hint);

                    errorBanner.style.display = 'block';

                } else if (errorBanner) {
                    errorBanner.style.display = 'none';
                }
            })
            .catch(function (err) {
                console.error('[Designer Cart Validation] Error:', err);
            });
    }

    function setupQuantityListeners() {
        document.querySelectorAll('input[data-cart-line]').forEach(function (input) {
            input.addEventListener('change', function () {
                setTimeout(validateCart, 300);
            });
            input.addEventListener('blur', function () {
                setTimeout(validateCart, 100);
            });
            input.addEventListener('invalid', function (e) {
                e.preventDefault();
            });
        });

        var originalFetch = window.fetch;
        window.fetch = function (url, options) {
            var result = originalFetch.apply(this, arguments);
            if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add.js'))) {
                result.then(function (response) {
                    if (url.includes('/cart/change') || url.includes('/cart/update')) {
                        setTimeout(validateCart, 300);
                    }
                    if (response && response.ok) {
                        document.dispatchEvent(new CustomEvent('nfckey:cart-mutated'));
                    }
                });
            }
            return result;
        };
    }

    injectStyles();

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            validateCart();
            setupQuantityListeners();
        });
    } else {
        validateCart();
        setupQuantityListeners();
    }

    window.validateDesignerCart = validateCart;

})();